export interface PageState {
  page: number;
  size: number;
  totalPages: number;
  totalElements: number;
}

export default class PageableRs {
  pages: PageState;

  constructor(rs: PageableRs) {
    this.pages = rs.pages;
  }
}
